import FixtureService from '../../services/FixturesService';
import { PRIVATE_EVENTS, PUBLIC_EVENTS, EVENT_CALLBACK } from '../../handlers/EventManager/constants';
import { ASSETS_IMAGES_BASE_URL } from '../../constants/AssetConstants';
import playImage from '../../images/play-white.png';
import notifyImage from '../../images/notification_unfilled.svg';
import tickImage from '../../images/Tick.png';
import './index.scss';
import { JSON_IMAGE_BASE_URL } from '../../constants/FixtureConstants';
import { convertTime } from '../../helpers/fixtureUtils';
const SI_IMAGE_URL = 'https://sportz.sonyliv.com/cricket/images/flags/rect';

const redStatusList = ['113'];

class FixtureWidgetCricket {
  constructor(sportsManager, fixtureConfig) {
    this.fixtureConfig = fixtureConfig;
    this.assetConfig = this.fixtureConfig.assetConfig
    this.jsonConfig = this.fixtureConfig.jsonManagerConfig
    this.sportsManager = sportsManager;
    if (!this.sportsManager) {
      throw new Error('Sports manager is required in Fixtures view.');
    }

    this.eventManager = this.sportsManager.eventManager;
    if (!this.eventManager) {
      throw new Error('Event manager is required in Fixtures view.');
    }

    this.parentDom = document.getElementById(this.assetConfig.parentId);
    if (!this.parentDom) {
      this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS?.SPORTS_MANAGER_ERROR, {
        errorCode: 'err_100',
        errorMessage: 'DOM element is required in fixtures view.',
      });
    }

    this.fixtureData = null;
    this.FEData = this.assetConfig.FEData;
    this.handleCTAClick = this.assetConfig.handleCtaClick;
    this.handleViewAllCard = this.assetConfig.handleViewAllCard;
    this.reminderIds = this.assetConfig.reminderIds;
    this.sportId = this.assetConfig.sportId;
    this.tourId = this.assetConfig.tourId;
    this.widgetCallback = this.assetConfig.widgetCallback

    if (!this.sportId || !this.tourId) {
      this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS?.SPORTS_MANAGER_ERROR, {
        errorCode: 'err_100',
        errorMessage: 'Sports id and tournament is required in fixtures view.',
      });
    }

    this.fixtureStatus = this.assetConfig.status;
    this.completedMatchLength = 0;
    this.liveMatchLength = 0;
    this.upcomingMatchLength = 0;
    this.subscribeToEvents();
  }

  subscribeToEvents() {
    this.eventManager.subscribeToEvents({
      eventType: EVENT_CALLBACK.PRIVATE_EVENTS,
      eventCallback: this.privateEventCallback.bind(this),
      senderName: 'FIXTURE_SERVICE',
    });
  }

  fixtureDataOrdering() {
    let completedMatch = []
    let upcomingMatch = []
    let liveMatch = []
    this.fixtureData.map((match) => {
      if(match?.is_live == true) {
        liveMatch.push(match)
      } else if (match?.is_complete == true) {
        completedMatch.push(match)
      } else if (match?.is_upcoming == true) {
        upcomingMatch.push(match)
      }
    });
    if(liveMatch.length > 0 || upcomingMatch?.length > 0) {
      completedMatch = completedMatch.reverse()
    }
    this.fixtureData = [...completedMatch, ...liveMatch, ...upcomingMatch]
    this.completedMatchLength = completedMatch?.length
    this.liveMatchLength = liveMatch?.length
    this.upcomingMatchLength = upcomingMatch?.length
  }

  privateEventCallback(eventName, eventData) {
    switch (eventName) {
      case PRIVATE_EVENTS.FIXTURE_UPDATE: {
        this.fixtureData = eventData?.fixtureWidgetData;
        this.tourMetaData = eventData?.tourMetaData;
        // this.fixtureDataOrdering();
        this.render();
        break;
      }

    }
  }

  getFixtureData() {
    const fixtureService = new FixtureService(this.sportsManager);
    fixtureService.fetchFixtureData(this.sportId, this.tourId, this.fixtureStatus, 0, PRIVATE_EVENTS.FIXTURE_UPDATE,this.jsonConfig);
  }

  destroyFixtureSDK() {
    if(this.parentDom) {
      this.parentDom.innerHTML = "";
      this.eventManager.broadcastPrivateEvent(PRIVATE_EVENTS.FIXTURE_WIDGET_DESTROY);
    }
  }

  renderCard(match,index) {
    let imageEndPoint = this.jsonConfig?.imageEndPoint ? this.jsonConfig?.imageEndPoint : JSON_IMAGE_BASE_URL;
    const fixtureCard = document.createElement('a');
    const fixtureOuterWrap = document.createElement('div');
    fixtureOuterWrap.setAttribute('class', 'fixture-outer-Wrap');
    fixtureOuterWrap.classList.add('fixture-card');

    this.handleCTAClick("SET_HREF", match?.match_metadata, (route, isHrefEnabled) => {
      fixtureCard.href = route
      if(isHrefEnabled === false) {
        fixtureCard.classList.add("disablePointer")
      }
    });
    if(this.completedMatchLength > 0 && index == this.completedMatchLength-1 && (this.liveMatchLength > 0 || this.upcomingMatchLength > 0) || match?.metaDatum?.objectSubtype == "LIVE_SPORT") {
      fixtureCard.classList.add("scrollToview")
    }

    const titleFixtureCard = document.createElement('div');
    titleFixtureCard.setAttribute('class', 'fixture-title-card');

    const matchName = document.createElement('a');
    matchName.innerText = match?.short_event_status;
    matchName.setAttribute('class', 'fixture-match-name');
    matchName.classList.add('match-result');
    redStatusList.includes( match?.event_status_id) ? matchName.classList.add('red-status') : '';

    this.handleCTAClick("SET_HREF", this.tourMetaData, (route, isHrefEnabled) => {
      matchName.href = route
      if(isHrefEnabled === false) {
        matchName.classList.add("disablePointer")
      }
    });

    titleFixtureCard.appendChild(matchName);
    fixtureOuterWrap.appendChild(titleFixtureCard);
    fixtureCard.appendChild(fixtureOuterWrap);

    // const fixtureMatchStatus = document.createElement('div');
    // fixtureMatchStatus.setAttribute('class', 'fixture-match-status');
    // fixtureMatchStatus.innerText = match?.matchstatus;
    // fixtureCard.appendChild(fixtureMatchStatus);

    const firstUpIndex = match?.participants?.findIndex(item => item?.firstup === "true");
    // If found, move it to the first index
    if (firstUpIndex !== -1) {
        const firstUpItem = match?.participants?.splice(firstUpIndex, 1)[0];
        match?.participants?.unshift(firstUpItem);
    }

    const teamDetails = document.createElement('div');
    teamDetails.setAttribute('class', 'fixture-team-details');
    fixtureOuterWrap.appendChild(teamDetails);

    const fixtureTeamA = document.createElement('div');
    fixtureTeamA.setAttribute('class', 'fixture-team');
    teamDetails.appendChild(fixtureTeamA);
    const homeLogoSrc = `${imageEndPoint}/${this.sportId}/${match.participants[0].id}.png`
    const homeDetails = this.renderTeamDetails('home', match?.participants[0].short_name, match.participants[0].id, homeLogoSrc, match);
    fixtureTeamA.appendChild(homeDetails);

    const scoreDetails = document.createElement('div');
    scoreDetails.setAttribute('class', 'fixture-detail-cont');
    teamDetails.appendChild(scoreDetails);

    const teamScore = document.createElement('div');
    teamScore.setAttribute('class', 'fixture-score');

    if (match.participants && match.event_status_id !== "115") {
      const createScoreElement = (className) => {
        const element = document.createElement('div');
        element.setAttribute('class', className);
        return element;
      };

      const teamAScoresValue = match.participants[0].value?.split('&');
      const teamBScoresValue = match.participants[1].value?.split('&');

      const teamFirstInningScore = createScoreElement('fixture-first-innings');
      const teamAScore = createScoreElement('fixture-teamA-score');
      const teamBScore = createScoreElement('fixture-teamB-score');
      teamFirstInningScore.appendChild(teamAScore);
      teamFirstInningScore.appendChild(teamBScore);
      teamScore.appendChild(teamFirstInningScore);

      const teamSecondInningScore = createScoreElement('fixture-second-innings');
      const teamA2Score = createScoreElement('fixture-teamA-score');
      const teamB2Score = createScoreElement('fixture-teamB-score');
      teamSecondInningScore.appendChild(teamA2Score);
      teamSecondInningScore.appendChild(teamB2Score);

      if(match.participants[0].highlight){
        teamAScore.classList.add('active-innings')
        teamA2Score.classList.add('active-innings')
      }

      if(match.participants[1].highlight){
        teamBScore.classList.add('active-innings')
        teamB2Score.classList.add('active-innings')
      }

      if(teamAScoresValue && teamAScoresValue[1] || teamBScoresValue && teamBScoresValue[1]){
        teamScore.appendChild(teamSecondInningScore);
      }

      const teamAOvers = createScoreElement('fixture-teamA-overs');
      const teamBOvers = createScoreElement('fixture-teamB-overs');
      teamScore.appendChild(teamAOvers);
      teamScore.appendChild(teamBOvers);

      const setScoreAndOvers = (scoreElement, oversElement, scoreValue) => {
        if (scoreValue) {
          //TODO split such that dec also comes in runs
            const [runs, overs] = scoreValue.includes('dec') ? scoreValue.trim().split('dec ') : scoreValue.trim().split(' ');
            const runsWithDec = scoreValue.includes('dec') ? `${runs} d` : runs;
            scoreElement.innerText = runsWithDec;
            oversElement.innerText = `${overs.replace(/[()]/g, '')} Overs`;
        }
      };

      

      if(teamAScoresValue && teamBScoresValue) {
        setScoreAndOvers(teamAScore, teamAOvers, teamAScoresValue[0]);
        setScoreAndOvers(teamBScore, teamBOvers, teamBScoresValue[0]);
        setScoreAndOvers(teamA2Score, teamAOvers, teamAScoresValue[1]);
        setScoreAndOvers(teamB2Score, teamBOvers, teamBScoresValue[1]);
      }

    } else {
      teamScore.innerText = convertTime(new Date(match.start_date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
    }
    scoreDetails.appendChild(teamScore);

    const fixtureTeamB = document.createElement('div');
    fixtureTeamB.setAttribute('class', 'fixture-team');
    teamDetails.appendChild(fixtureTeamB);
    const awayLogoSrc = `${imageEndPoint}/${this.sportId}/${match.participants[1].id}.png`
    const awayDetails = this.renderTeamDetails('away', match?.participants[1].short_name, match.participants[1].id, awayLogoSrc, match);
    fixtureTeamB.appendChild(awayDetails);

    let reminderIds = typeof localStorage != "undefined" && localStorage.getItem("sports_reminders") ? JSON.parse(localStorage.getItem("sports_reminders")) : this.reminderIds;
    let reminderAddId = typeof localStorage != "undefined" && localStorage.getItem("reminderMatchTourId") ?  localStorage.getItem("reminderMatchTourId") : "";
    if(reminderAddId && !reminderIds.includes(reminderAddId)) {
      reminderIds.push(reminderAddId)
    }
    let isSetReminder = reminderIds?.filter((item) => {
      return item.includes(match.match_id);
    });

    if(match.teama_score && match.teamb_score && match?.is_complete == true) {
      const scoreTextCont = document.createElement('div');
      scoreTextCont.setAttribute('class', 'fixture-score-text-concluded');
      scoreTextCont.innerText = match?.matchStatus;
      scoreDetails.appendChild(scoreTextCont);
    }

    if ((match?.metaDatum?.objectSubtype == "HIGHLIGHTS" && match?.metaDatum?.contentId != 0)) {
      const buttonsContainer = document.createElement('div');
      buttonsContainer.setAttribute('class', 'fixture_btn_container');
      fixtureOuterWrap.appendChild(buttonsContainer);
      const fixtureButtonContainer = document.createElement('a');
      fixtureButtonContainer.setAttribute('class', 'fixture-button-cont fixture-match-completed');
      fixtureButtonContainer.href = "javascript:void(0);";
      const ActionImg = new Image();
      ActionImg.src = playImage;
      fixtureButtonContainer.appendChild(ActionImg);
      const fixtureButtonText = document.createElement('div');
      fixtureButtonText.setAttribute('class', 'fixture-button-text');
      fixtureButtonText.textContent = 'Watch Highlights';
      fixtureButtonContainer.appendChild(fixtureButtonText);
      fixtureButtonContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleCTAClick('WATCH_HIGHLIGHTS_EVENTS', match);
      });
      buttonsContainer.appendChild(fixtureButtonContainer);
    } else if (!match?.metaDatum?.objectSubtype && match?.event_status_id == "115" && (match?.match_id!= 0 || match?.metaDatum?.contentId != 0) && match?.releaseStartDate != 0 && match?.releaseStartDate > Date.now()) {
      const buttonsContainer = document.createElement('div');
      buttonsContainer.setAttribute('class', 'fixture_btn_container');
      fixtureOuterWrap.appendChild(buttonsContainer);
      const fixtureButtonContainer = document.createElement('a');
      fixtureButtonContainer.setAttribute('class', 'fixture-button-cont fixture-match-completed');
      fixtureButtonContainer.href = "javascript:void(0);";
      const ActionImg = new Image();
      ActionImg.src =  playImage;
      fixtureButtonContainer.appendChild(ActionImg);
      const fixtureButtonText = document.createElement('div');
      fixtureButtonText.setAttribute('class', 'fixture-button-text');
      fixtureButtonText.textContent = 'Watch Preview';
      fixtureButtonContainer.appendChild(fixtureButtonText);
      fixtureButtonContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleCTAClick('WATCH_PREVIEW_EVENTS', match);
      });

      if(match?.metaDatum?.contentId != 0){
        buttonsContainer.appendChild(fixtureButtonContainer);
      }

      const fixtureNotificationContainer = document.createElement('a');
      fixtureNotificationContainer.setAttribute('class', 'fixture-button-notification fixture-match-completed');
      fixtureNotificationContainer.href = "javascript:void(0);";
      const NotificationImg = new Image();
      NotificationImg.src = notifyImage;
      const fixtureNotificationText = document.createElement('span');
      fixtureNotificationText.setAttribute('class', 'fixture-notification-text');
      fixtureNotificationText.innerHTML = 'Set Reminder'
      fixtureNotificationContainer.appendChild(NotificationImg);
      fixtureNotificationContainer.appendChild(fixtureNotificationText);

      if(isSetReminder?.length > 0) {
        fixtureNotificationContainer.classList.add("disabled")
        NotificationImg.src = tickImage;
        fixtureNotificationText.innerHTML = 'Reminder Set'
      }
      fixtureNotificationContainer.addEventListener("click",(e) => {
        e.stopPropagation();
        if(!e.currentTarget.classList.contains("disabled")) {
          this.handleCTAClick("SET_REMINDER_EVENTS",match,(setReminderStatus) => {
            if(setReminderStatus == true) {
              fixtureNotificationContainer.classList.add("disabled")
              NotificationImg.src = tickImage;
              fixtureNotificationText.innerHTML = 'Reminder Set'
            }
          });
        }
      });
      buttonsContainer.appendChild(fixtureNotificationContainer);
    } else if (match?.metaDatum?.objectSubtype == "LIVE_SPORT" && match?.metaDatum?.contentId != 0) {
      const buttonsContainer = document.createElement('div');
      buttonsContainer.setAttribute('class', 'fixture_btn_container');
      fixtureOuterWrap.appendChild(buttonsContainer);
      const fixtureButtonContainer = document.createElement('a');
      fixtureButtonContainer.setAttribute('class', 'fixture-button-cont');
      fixtureButtonContainer.classList.add('live-btn-container');
      fixtureButtonContainer.href = "javascript:void(0);";
      const liveIcon = document.createElement('div');
      liveIcon.setAttribute('class', 'live-circle')
      fixtureButtonContainer.appendChild(liveIcon);
      const fixtureButtonText = document.createElement('div');
      fixtureButtonText.setAttribute('class', 'fixture-button-text');
      fixtureButtonText.classList.add('live-btn');
      fixtureButtonText.textContent = 'Watch Live';
      fixtureButtonContainer.appendChild(fixtureButtonText);
      if(match?.metaDatum?.contractStartDate != 0 && match?.metaDatum?.contractStartDate > Date.now()){
        fixtureButtonContainer.style.display = 'none'
        let delta = match?.metaDatum?.contractStartDate - Date.now()
        setTimeout(()=> {
            fixtureButtonContainer.style.display = 'flex'
        },delta)
      }
      fixtureButtonContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleCTAClick('WATCH_LIVE_EVENTS', match);
      });
      buttonsContainer.appendChild(fixtureButtonContainer);
    }

    if(typeof localStorage != "undefined" && localStorage.getItem("FIXTURE_CLICK_ENABLED") == 'true') {
      fixtureCard.addEventListener("click",(e) => {
        e.preventDefault();
        this.handleCTAClick("FIXTURE_CARD_CLICK", match);
      });
    }

    const tourNameContainer = document.createElement('div');
    tourNameContainer.setAttribute('class', 'tour-name-container');
    tourNameContainer.innerText = match?.tour_name;
    fixtureCard.appendChild(tourNameContainer);
    // document.getElementsByClassName('fixture-container-slides')[0].appendChild(fixtureCard);

    const matchDate = document.createElement('div');
    matchDate.setAttribute('class', 'fixture-match-date-outer');
    const dateFormat = new Date(match?.start_date).toLocaleDateString('en-US', {
      weekday: 'long', day: '2-digit', month: 'short' 
    });

    matchDate.innerText = `${dateFormat}`;
    fixtureCard.appendChild(matchDate);
    
    this.wrapperSlides.appendChild(fixtureCard);
  }

  renderTeamDetails(teamType, teamName, teamId, image, match) {
    const logoImg = new Image();
    logoImg.src = image;
    logoImg.onerror = function (e) {
        logoImg.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
    }
    logoImg.alt = teamName;
    const classList = `team-info-wrapper team-info-wrapper--${teamType}`;
    let wrapper = document.createElement('a');
    wrapper.setAttribute('class', classList);
    let teamMetaData = match?.teama_metadata;
    if(teamType === "away") {
        teamMetaData = match?.teamb_metadata;
    }
    this.handleCTAClick("SET_HREF", teamMetaData, (route, isHrefEnabled) => {
        wrapper.href = route
        if(isHrefEnabled === false) {
          wrapper.classList.add("disablePointer")
        }        
    });
    const teamLabel = document.createElement('div');
    teamLabel.setAttribute('class', 'team-name-label');
    teamLabel.innerText = teamName;
    wrapper.appendChild(logoImg);
    wrapper.appendChild(teamLabel);
    return wrapper;
  }

  render() {
    if (this.parentDom && this.fixtureData.length > 0) {
      const numberOfCards = this.FEData?.metadata?.number_ofcard_displayed || 10;
      const wrapper = document.createElement('div');
      wrapper.setAttribute('class', 'fixture-container-cricket');
      this.parentDom.appendChild(wrapper);
      const leftArrowCont = document.createElement('div');
      leftArrowCont.setAttribute('id', 'fixture-prev-arrow');
      wrapper.appendChild(leftArrowCont);
      this.wrapperSlides = document.createElement('div');
      this.wrapperSlides.setAttribute('class', 'fixture-container-slides');
      wrapper.appendChild(this.wrapperSlides);

      const matches = this.fixtureData.slice(0, numberOfCards)

      const showConcluded = matches.some(
        (match) =>
          (match.cricket?.event_state && match.cricket?.event_state === 'R') ||
          (match.event_state && match.event_state === 'R')
      );
      const showUpcoming = matches.some(
        (match) =>
          (match.cricket?.event_state && match.cricket?.event_state === 'U') ||
          (match.event_state && match.event_state === 'U')
      );

      if(this.fixtureStatus !== "upcoming" && showConcluded) {
        const fixtureCardViewConclude = document.createElement('div');
        fixtureCardViewConclude.setAttribute('class', 'fixture-card fixture-card-view-cont');
        const fixtureVeiwAllConcludeLabel = document.createElement('div');
        fixtureVeiwAllConcludeLabel.setAttribute('class', 'fixture-card-view-all');
        fixtureVeiwAllConcludeLabel.innerText = 'View All Concluded Games';
        fixtureCardViewConclude.appendChild(fixtureVeiwAllConcludeLabel);
        fixtureCardViewConclude?.addEventListener('click', () => { this.handleViewAllCard(this.tourMetaData, 'concluded') } );
        if(document.getElementsByClassName('fixture-container-slides').length >  0) {
          this.wrapperSlides.appendChild(fixtureCardViewConclude);
        }
      }

      matches.map((match,index) => {
        this.renderCard(match?.cricket ? match?.cricket : match, index);
      });

      if(this.fixtureStatus !== "concluded" && showUpcoming) {
        const fixtureCardViewCont = document.createElement('div');
        fixtureCardViewCont.setAttribute('class', 'fixture-card fixture-card-view-cont');
        const fixtureVeiwAllLabel = document.createElement('div');
        fixtureVeiwAllLabel.setAttribute('class', 'fixture-card-view-all');
        fixtureVeiwAllLabel.innerText = 'View All Upcoming Games';
        fixtureCardViewCont.appendChild(fixtureVeiwAllLabel);
        fixtureCardViewCont?.addEventListener('click', () => { this.handleViewAllCard(this.tourMetaData, 'upcoming') } );
        if(document.getElementsByClassName('fixture-container-slides').length >  0) {
          // document.getElementsByClassName('fixture-container-slides')[0].appendChild(fixtureCardViewCont);
          this.wrapperSlides.appendChild(fixtureCardViewCont);
        }
      }
      const rigthArrowCont = document.createElement('div');
      rigthArrowCont.setAttribute('id', 'fixture-next-arrow');
      wrapper.appendChild(rigthArrowCont);

      rigthArrowCont.addEventListener('click', () => {
        this.wrapperSlides.scrollLeft += this.wrapperSlides.clientWidth / 1.5;
      });

      leftArrowCont.addEventListener('click', () => {
        this.wrapperSlides.scrollLeft -= this.wrapperSlides.clientWidth / 1.5;
      });

      this.wrapperSlides.onscroll = (event) => {
        this.toggleArrows(this.wrapperSlides, rigthArrowCont, leftArrowCont);
      };

      this.widgetCallback("FIXTURE_RENDER_SUCCESS",this.tourMetaData)

      let element =
        this.wrapperSlides.getElementsByClassName('live-btn-container')[0] ||
        this.wrapperSlides.getElementsByClassName('fixture-button-notification')[0];
      setTimeout(()=> {
        if(element) {
          let elementRect = element?.getBoundingClientRect();
          this.wrapperSlides.scroll({ 
            left: elementRect.left - 120, 
            behavior: "smooth" 
          });
        }
      }, 0)
        
      this.toggleArrows(this.wrapperSlides, rigthArrowCont, leftArrowCont);

    }
  }

  toggleArrows(container, rigthArrowCont, leftArrowCont) {
    if (container.scrollLeft === 0) {
      leftArrowCont.style.display = 'none';
      container.style.marginLeft ='4.3924vw';
    } else {
      leftArrowCont.style.display = 'block';
      container.style.marginLeft = 0;
    } 

    if (container.scrollLeft + container.clientWidth === container.scrollWidth) {
      rigthArrowCont.style.display = 'none';
    } else {
      rigthArrowCont.style.display = 'block';
      if (container.scrollLeft > 0) {
        leftArrowCont.style.display = 'block';
      }
    }
  }

}

export default FixtureWidgetCricket;
